import { render, staticRenderFns } from "./doctorInfo.vue?vue&type=template&id=f0f5c344&scoped=true&"
import script from "./doctorInfo.vue?vue&type=script&lang=js&"
export * from "./doctorInfo.vue?vue&type=script&lang=js&"
import style0 from "./doctorInfo.vue?vue&type=style&index=0&id=f0f5c344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f5c344",
  null
  
)

export default component.exports